'use strict';

// TOM Premium Membership の種類
const SERVICE_SLUG = {
  PREMIUM: 'premium'
};
const PLAN_SLUG = {
  QUARTERLY: 'quarterly',
  ANNUAL: 'annual'
};

// プランの種類
const PLAN_TYPE = {
  FIRST: 'first', // 初回契約時に適応される設定
  RENEWAL: 'renewal', // 契約更新時に適応される設定
  RECONTRACT: 'recontract' // 再契約に適応される設定
};

const REFERER_TYPE = {
  CART: 'cart', // ショップの決済と同時にPremiumに加入する
  REAL_EVENT: 'real_event', // イベントでのPremium加入 @deprecated
  PROJECT: 'project', // ProjectsでのPremium加入
  PREMIUM_JOIN: 'premium_join', // 通常入会フォーム経由
  PREMIUM_ORDER: 'premium_order', // /orders/premium 経由
  PREMIUM_ORDER_CANCELLATION: 'premium_order_cancellation' // /orders/premium/cancellation 経由
};

const BENEFIT_TYPE = {
  /**
   * 入会すれば必ず得られるベネフィット
   *
   *   - EXCLUSIVE DISCOUNTS
   *   - TOM POINTS NEVER EXPIRE
   *   - DAILY GAMEPLAY CREDIT
   *   - DAILY MANGA TICKETS
   *   - INSIDER REPORTS
   *   - DOWNLOAD WALL PAPERS
   */
  BASIC: 'basic',

  /**
   * Renewalにともない追加で必ず得られるベネフィット
   *
   *   - SAVE ON SHIPPING
   *   - RAISE PREMIUM POINT RATE
   */
  PLUS: 'plus',

  // PremiumPlans.type[TYPE].pointを得られるベネフィット
  POINT_BACK: 'point_back',

  // ANiUTa有料サービスを得られるベネフィット
  ANIUTA: 'aniuta' // @deprecated
};

const PLAN_SLUG_PATTERN = Object.keys(PLAN_SLUG).map((key) => PLAN_SLUG[key]);

const PLAN_TYPE_PATTERN = Object.keys(PLAN_TYPE).map((key) => PLAN_TYPE[key]);

const BENEFIT_TYPE_PATTERN = Object.keys(BENEFIT_TYPE).map(
  (key) => BENEFIT_TYPE[key]
);

// 自動更新の何日前にリマインダーを送るかの設定
const REMINDER_DAYS_BEFORE_AUTO_RENEWAL = 3;

// recontract 時に特定条件で得られる extra ポイント
const RECONTRACT_EXTRA_POINT = 1000;

// recontract キャンセル禁止日数
const RECONTRACT_CANCEL_BLOCK_DAYS = 45;

const premiumSchema = (module.exports = {
  SERVICE_SLUG: SERVICE_SLUG,
  PLAN_SLUG: PLAN_SLUG,
  PLAN_TYPE: PLAN_TYPE,
  PLAN_SLUG_PATTERN: PLAN_SLUG_PATTERN,
  PLAN_TYPE_PATTERN: PLAN_TYPE_PATTERN,
  REFERER_TYPE: REFERER_TYPE,
  BENEFIT_TYPE: BENEFIT_TYPE,
  BENEFIT_TYPE_PATTERN: BENEFIT_TYPE_PATTERN,
  REMINDER_DAYS_BEFORE_AUTO_RENEWAL,
  RECONTRACT_EXTRA_POINT,
  RECONTRACT_CANCEL_BLOCK_DAYS,

  /**
   * Premium 会員に入会中 or 入会前提のカートか判定する。 (doc が ShoppingCarts の場合)
   * Premium 会員に入会中のオーダーか判定する。 (doc が Orders の場合)
   *   会員期限が有効か判断する method ではありません。
   *
   * @param {ShoppingCarts|Orders} doc
   * @return {Boolean}
   */
  hasPremiumPlan: function (doc) {
    if (doc && doc.premium && doc.premium.plan) {
      return true;
    }
    return false;
  },

  /**
   * planType を元に対応する benefits を返す
   *
   * @param {String} planType
   * @returns {Array} benefits
   */
  getBenefits(planType) {
    let results = [];

    switch (planType) {
      case PLAN_TYPE.FIRST:
        results = [BENEFIT_TYPE.BASIC, BENEFIT_TYPE.POINT_BACK];
        break;
      case PLAN_TYPE.RENEWAL:
      case PLAN_TYPE.RECONTRACT:
        results = [
          BENEFIT_TYPE.BASIC,
          BENEFIT_TYPE.PLUS,
          BENEFIT_TYPE.POINT_BACK
        ];
        break;
    }

    return results;
  },

  /**
   * Recontract 経験のあるユーザーがキャンセル不可の場合キャンセル可能日を返す
   * @param {PremiumSubscriptions} subscription
   * @returns {Date} キャンセル可能日もしくは null
   */
  recontractCancellationOpenDate(subscription) {
    if (!subscription.started_at) {
      return null;
    }

    // RECONTRACT_CANCEL_BLOCK_DAYS はブロック期間なので
    // キャンセルは +1 した日から可能
    const dt = new Date(subscription.started_at.getTime());
    dt.setDate(dt.getDate() + RECONTRACT_CANCEL_BLOCK_DAYS + 1);
    const now = new Date();
    if (dt <= now) {
      return null;
    }
    return dt;
  },

  /**
   * キャンセル可能なら true
   * @param {PremiumSubscriptions} subscription
   * @returns {Boolean}
   */
  isCancelableSubscription(subscription) {
    const dt = premiumSchema.recontractCancellationOpenDate(subscription);
    return dt === null;
  }
});
